import React, { useContext, useState } from "react";
import { FaChevronCircleLeft, FaPlus } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { Timeout, formattedDate } from "../../functions/functions";
import { DataExpenseContext, ShowExpenseContext } from "./types";
import { AddExpenseApi } from "../../redux/expense/expenseApiCalls";
import ShowErrorMsg from "../../HtmlComponents/ShowErrorMsg";
import ButtonsForm from "../../HtmlComponents/ButtonsForm";
import InputsExpenses from "./forms/InputsExpenses";
import { useNavigate } from "react-router";

const AddNewExpense = () => {
  const [note, setNote] = useState("");
  const [amount, setAmount] = useState("");
  const [createdAt, setCreatedAt] = useState(formattedDate(new Date().toDateString()));
  const [errors, setErrors] = useState([]);
  
  const dispatch: any = useDispatch();
  
  const [modal, setModal] = useState(false);
  const toggle = () => {
    setModal(!modal);
  };

  const { setShowSuccessMsg } = useContext(ShowExpenseContext)

  const [loading, setLoading] = useState(false)

  const handleSubmitExpense = async (e: any) => {
    e.preventDefault();
    setLoading(true)
    try {
      const response: any = await dispatch(AddExpenseApi({ note, amount, createdAt }));
      if (response === true) {
        toggle();
        setShowSuccessMsg(true);
        setTimeout(() => setShowSuccessMsg(false), Timeout);
        setNote("");
        setAmount("");
        setErrors([]);
      } else {
        setErrors(response);
      }
    } finally {
      setLoading(false)
    }
  };

  const navigate = useNavigate()

  return (
    <DataExpenseContext.Provider value={{
      note, setNote,
      amount, setAmount,
      createdAt, setCreatedAt
    }}>
      <div className="flex justify-start gap-2">
          <FaChevronCircleLeft style={{ fontSize: "30px" }} className="text-main" onClick={() => navigate(-1)}/>
          <button className="p-2 rounded btn-main" onClick={toggle}>
            <FaPlus />
          </button>
        </div>
      {modal && (
        <>
          <div className="fixed inset-0 z-10 overflow-y-auto">
            <div
              className="fixed inset-0 w-full h-full bg-black opacity-40"
              onClick={toggle}
            ></div>
            <div className="flex items-center min-h-screen px-4 py-8">
              <div className="relative w-full max-w-lg p-4 mx-auto bg-white rounded-md shadow-lg">
                <div className="mt-3">
                  {/* Start Modal Body */}
                  <form
                    className="mt-2 sm:ml-4 sm:text-left"
                    onSubmit={handleSubmitExpense}
                  >
                    <ShowErrorMsg errors={errors} setErrors={setErrors} />
                    <InputsExpenses />
                    <ButtonsForm loading={loading} typeBtn="Ajouter" toggle={toggle} />
                  </form>
                  {/* End Modal Body */}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </DataExpenseContext.Provider>
  );
};

export default AddNewExpense;
